import { supabase } from "./supabase";

// Yönetim paneli veri katmanı. Migration henüz çalıştırılmadıysa
// tablo hatalarını yakalayıp UI'ın "kurulum bekliyor" göstermesini sağlar.

export const MIGRATION_MISSING = "MIGRATION_MISSING";

function wrap(error) {
  const code = error?.code || "";
  const msg = error?.message || "";
  if (code === "PGRST205" || code === "42P01" || msg.includes("does not exist") || msg.includes("schema cache")) {
    return MIGRATION_MISSING;
  }
  return error;
}

async function q(promise) {
  const { data, error } = await promise;
  if (error) throw wrap(error);
  return data;
}

// Yalnızca satır sayısını döndürür (veri çekmeden)
async function countRows(table) {
  const { count, error } = await supabase.from(table).select("id", { count: "exact", head: true });
  if (error) throw wrap(error);
  return count ?? 0;
}

// ---- Genel bakış istatistikleri ----
export async function getOverviewStats() {
  const [totalVehicles, quotes, totalCustomers, rentals] = await Promise.all([
    countRows("vehicles"),
    q(supabase.from("quote_requests").select("id, status")),
    countRows("customers"),
    q(supabase.from("rentals").select("monthly_rate").eq("status", "aktif")),
  ]);
  return {
    totalVehicles,
    totalQuotes: quotes.length,
    pendingQuotes: quotes.filter((x) => x.status === "yeni").length,
    totalCustomers,
    activeRentals: rentals.length,
    monthlyRevenue: rentals.reduce((sum, r) => sum + Number(r.monthly_rate || 0), 0),
  };
}

// ---- Müşteriler ----
export const listCustomers = () => q(supabase.from("customers").select("*").order("created_at", { ascending: false }));
export const upsertCustomer = (row) =>
  q(row.id ? supabase.from("customers").update(row).eq("id", row.id).select().single() : supabase.from("customers").insert(row).select().single());
export const deleteCustomer = (id) => q(supabase.from("customers").delete().eq("id", id).then((r) => ({ data: true, error: r.error })));

// ---- Kiralamalar ----
export const listRentals = () =>
  q(supabase.from("rentals").select("*, vehicles(name), customers(name)").order("created_at", { ascending: false }));
export const upsertRental = (row) =>
  q(row.id ? supabase.from("rentals").update(row).eq("id", row.id).select().single() : supabase.from("rentals").insert(row).select().single());
export const deleteRental = (id) => q(supabase.from("rentals").delete().eq("id", id).then((r) => ({ data: true, error: r.error })));

// Çakışma kontrolü (UI'da erken uyarı; asıl güvence DB'deki exclusion constraint)
export async function findRentalConflict(vehicleId, startDate, endDate, excludeId = null) {
  let query = supabase
    .from("rentals")
    .select("id, start_date, end_date")
    .eq("vehicle_id", vehicleId)
    .eq("status", "aktif")
    .lte("start_date", endDate)
    .gte("end_date", startDate);
  if (excludeId) query = query.neq("id", excludeId);
  const { data, error } = await query;
  if (error) throw wrap(error);
  return data && data.length > 0 ? data[0] : null;
}

// ---- Site ayarları ----
export const listSettings = () => q(supabase.from("site_settings").select("*"));
export const saveSetting = (key, value) =>
  q(supabase.from("site_settings").update({ value }).eq("key", key).select().single());

// ---- Teklif durumu / not ----
export const updateQuote = (id, patch) => q(supabase.from("quote_requests").update(patch).eq("id", id).select().single());
